<template>
  <hm-content title="">
    <div class="table-panel flex flex-between">
      <div>
        <el-button type="primary" class="mr10" size="small" @click="gogogo"
          >批量添加复购商品</el-button
        >
      </div>
      <div>
        <el-input
          clearable
          v-model.trim="searchCondition.spuName"
          placeholder="请输入商品名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
    </div>
    <div class="flex flex-end mb10">
      <div @click="outputExcel" class="delete mr20 pointer">
        <span class="delete-icon hmicon icon-daochu"></span>
        导出模板
      </div>
      <div class="delete mr20 pointer open-file">
        <span class="delete-icon hmicon icon-daoru"></span>
        导入
        <input
          type="file"
          @change="importf"
          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        />
      </div>
    </div>
    <div>
      <el-table
        stripe
        ref="brandTable"
        border
        @selection-change="getChecked"
        :data="list"
        style="width: 100%"
        id="table"
        size="small"
      >
        <!-- <el-table-column type="selection"></el-table-column> -->
        <el-table-column
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="left"
          align="left"
          prop="spuName"
          label="商品名称"
          show-overflow-tooltip
          width="420"
        ></el-table-column>
        <el-table-column
          header-align="left"
          align="left"
          prop="goodsSn"
          label="货号"
          show-overflow-tooltip
        ></el-table-column>
        <!-- <el-table-column
          header-align="left"
          align="left"
          prop="specBarcode"
          label="条码"
          show-overflow-tooltip
        ></el-table-column> -->
        <el-table-column
          header-align="left"
          align="left"
          prop="specIdGroupName"
          label="商品规格"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          header-align="left"
          align="left"
          prop="categoryName"
          label="商品类目（所属末级）"
          width="180"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          header-align="left"
          align="left"
          prop="repurchaseCycleNum"
        >
          <template slot="header">
            复购周期（取整数部分）
            <el-tooltip
              class="tooltip"
              effect="light"
              content="手动设置的单品使用周期，仅取整数部分"
              placement="top"
            >
              <i class="el-icon-question" style="font-size: 16px"></i>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <div @click="setting(scope.row)" class="pointer">
              <i style="font-size: 16px" class="el-icon-setting blue"></i>
              <span> {{ scope.row.repurchaseCycleNum }}</span
              >天
            </div>
          </template>
        </el-table-column>
        <el-table-column header-align="left" align="left" prop="spuName">
          <template slot="header">
            近1月实际复购周期区间
            <el-tooltip
              class="tooltip"
              effect="light"
              content="系统根据消费者在店铺的购买行为计算得来的复购周期"
              placement="top"
            >
              <i class="el-icon-question" style="font-size: 18px"></i>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <div v-if="scope.row.repurchaseCycleMinValue">
              {{ scope.row.repurchaseCycleMinValue || 0 }}天-{{
                scope.row.repurchaseCycleMaxValue || 0
              }}天
            </div>
            <div v-else class="gray">-</div>
          </template>
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          label="操作"
          width="250"
        >
          <template slot-scope="scope">
            <el-button
              size="small"
              class="blue"
              type="text"
              @click="toDetails(scope.row)"
              >查看详情</el-button
            >
            <el-divider direction="vertical"></el-divider>
            <el-button
              size="small"
              class="blue"
              type="text"
              @click="setting(scope.row)"
              >编辑复购周期</el-button
            >
            <el-divider direction="vertical"></el-divider>
            <el-button
              size="small"
              class="danger"
              type="text"
              @click="del(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
    <hm-batch-purchase-cycle
      :visible="dialogVisibleBatch"
      @close="dialogVisibleBatch = false"
      @confirm="confirm"
      title="编辑复购周期"
      ref="purchasecycle"
      :goodsName="row.spuName"
    >
    </hm-batch-purchase-cycle>
    <el-dialog :visible.sync="errValidGoods" width="40%" title="提示">
      <div>
        <div>
          您有
          <span class="error">{{ errInputResult.length }}</span
          >条数据有误， 请<span class="blue pointer" @click="outputExcelErr"
            >保存条码到本地</span
          >,到商品库中检查该条码是否有修改，如有修改请复制新的条码到批量添加中继续添加
        </div>
        <el-table
          :data="errInputResult"
          ref="errTable"
          border
          class="small-table"
        >
          <el-table-column
            type="index"
            label="序号"
            header-align="center"
            align="center"
            width="50"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="无效条码"
            prop="errBarCode"
          >
            <template slot-scope="scope">
              {{ scope.row }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
import HmBatchPurchaseCycle from "@/components/HmBatchPurchaseCycle";
import XLSX from "xlsx";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串

export default {
  components: { HmBatchPurchaseCycle },
  data() {
    return {
      errValidGoods: false,
      errInputResult: [],
      dialogVisibleBatch: false,
      total: 0,
      list: [],
      pageSize: 10,
      currentPage: 1,
      searchCondition: {},
      checkedRow: [],
      row: {}
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    outputExcelErr() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const list = [];

        this.errInputResult.forEach(v => {
          list.push({ errBarCode: v });
        });
        const tHeader = this.$refs.errTable.columns
          .map(o => o.label !== "序号" && o.label !== "操作" && o.label)
          .filter(o => o);

        let filterVal = [];
        if (list.length > 0) {
          filterVal = this.$refs.errTable.$children
            .map(o => o._props.prop)
            .filter(o => o);
        }
        const data = this.formatJson(filterVal, list);
        exportJsonToExcel(tHeader, data, "错误条码");
      });
    },
    // 导出excel
    outputExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = ["商品条码（必填）", "复购周期（必填）"];
        const filterVal = [];
        const data = this.formatJson(filterVal, []);
        exportJsonToExcel(tHeader, data, "复购商品导入模板");
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    // 导入excel
    importf(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64"
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary"
          });
        }
        let result = null;
        wb.SheetNames.forEach(sheetName => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        let repurchaseSkuInfoModels = [];
        result.forEach(v => {
          if (v[0] && v[1]) {
            repurchaseSkuInfoModels.push({
              specBarcode: v[0] || "",
              repurchaseCycleNum: v[1]
            });
          }
        });

        that.$store
          .dispatch("batchSaveRepurchaseSkuByImport", {
            repurchaseSkuInfoModels
          })
          .then(res => {
            const { code, result } = res;

            if (code === "0") {
              const { errList } = result;
              if (errList.length) {
                that.errValidGoods = true;
                that.errInputResult = errList;
              }
              that.queryList();
            }
          });
        // const formatResult = [];
        // let isValidPhone = true;
        // if (result.length > 0) {
        //   result.forEach(v => {
        //     if (!v[0] || !v[6]) {
        //       isValidPhone = false;
        //     }
        //     formatResult.push({
        //       goodsSn: v[0],
        //       wxshopSpuName: v[1],
        //       eachPurchaseLimit: v[2],
        //       bargainTotalStockSum: v[3],
        //       retailPrice: v[4],
        //       seckillPrice: v[5],
        //       specBarcode: v[6],
        //       roundSeqNumGroupArray: []
        //     });
        //   });
        // } else {
        //   isValidPhone = false;
        // }

        // if (isValidPhone) {
        //   let errList = formatResult.filter((item, index, self) => {
        //     for (let i = index + 1; i < self.length; i++) {
        //       if (self[i].specBarcode === item.specBarcode) {
        //         return true;
        //       }
        //     }
        //     return false;
        //   });
        //   if (errList.length > 0) {
        //     that.errValidGoods = true;
        //     that.errInputResult = errList;
        //     that.$message({
        //       message: "导入失败，有重复条码！",
        //       type: "warning"
        //     });
        //   } else {
        //     that.rule.seckillGoodsRuleList = formatResult;
        //   }
        //   // that.memberCount = formatResult.length;
        // } else {
        //   that.$message({
        //     message: "货号和条码不能为空！",
        //     type: "warning"
        //   });
        // }
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    toDetails(row) {
      this.$router.push({
        name: "PotentialGoodsOrder",
        query: {
          row: JSON.stringify(row)
        }
      });
    },
    del(row) {
      this.$confirm("是否确定删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$store.dispatch("delRepurchaseSku", row).then(res => {
          if (res.code === "0") {
            this.$message({
              message: "操作成功！",
              type: "success"
            });
            this.queryList();
          }
        });
      });
    },
    setting(row) {
      this.row = row;
      this.dialogVisibleBatch = true;
      this.$refs.purchasecycle.repurchaseCycleNum = row.repurchaseCycleNum;
    },
    confirm(val) {
      this.row.repurchaseCycleNum = val;
      this.$store
        .dispatch("editRepurchaseSkuCycleValue", this.row)
        .then(res => {
          if (res.code === "0") {
            this.$message({
              message: "操作成功！",
              type: "success"
            });
            this.queryList();
            this.dialogVisibleBatch = false;
          }
        });
    },
    gogogo() {
      this.$router.push({
        name: "BatchSettingPurchaseGoods"
      });
    },
    getChecked(selection) {
      console.log("selection: ", selection);
      //   this.checkedRow = selection.map(v => v.wxshopSpuId);
    },
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "queryStoreRepurchaseSkuInfoList",
        params
      );
      if (code === "0") {
        const { total, records } = result;
        this.list = records;
        this.total = total;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    }
  }
};
</script>
<style lang="scss" scoped></style>
